// Global JS

(function nerivioGlobal($, Drupal) {
  Drupal.behaviors.accessibilityChanges = {
    attach(context) {
      /* Add tabindex attribute to H tags if not present. */
      $('h1, h2, h3, h4, h5, h6', context).each(function () {
        if (!$(this).attr('tabindex')) {
          $(this).attr('tabindex', 0);
        }
      });

      
      // Store the target URL when clicking on an external link
      var targetUrl = '';

      // Show modal when clicking on external links
      $(".external-link-popup", context).once('external-link-handler').on('click', function (e) {
        e.preventDefault();
        targetUrl = $(this).attr('href');
        $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "block");
      });

      // Close modal handlers - Cancel button
      $(".custom-modal .btn-secondary", context).once('cancel-button-handler').on('click', function () {
        $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "none");
      });

      // Continue button handler
      $(".custom-modal .btn-primary", context).once('continue-button-handler').on('click', function () {
        if (targetUrl) {
          window.open(targetUrl, '_blank');
        }
        $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "none");
      });

      // Close the modal when close button is clicked
      $(".custom-modal .custom-ui-dialog-titlebar-close", context).once('close-button-handler').on('click', function () {
        $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "none");
      });

      // Close the modal when clicking outside the modal content
      const $leaveModal = $('.custom-modal');
      $(document).mouseup(function (e) {
        if (!$leaveModal.is(e.target) && $leaveModal.has(e.target).length === 0) {
          $(".custom-modal, .custom-modal + .custom-ui-widget-overlay").css("display", "none");
        }
      });
    }
  };
})(jQuery, Drupal);

//scrolling issue fix
window.addEventListener("load", function () {
  const hash = window.location.hash;

  if (hash) {
    setTimeout(() => {
      const target = document.querySelector(hash);
      if (target) {
        let offset = 0;

        if (window.innerWidth <= 390) {
          offset = 150;
        } else if (window.innerWidth <= 768) {
          offset = 180;
        } else {
          offset = 120;
        }

        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - offset,
          behavior: "smooth"
        });
      }
    }, 100);
  }
});

// Pass event to datalayer on click of logo.
function handleLogoClick(event) {
  dataLayer.push({
    event: "logo_click"
  });
}
const logoLink = document.querySelector('.logo-link');
if (logoLink) {
  logoLink.addEventListener('click', handleLogoClick);
}

// Pass event to datalayer on click on links in text component.
function handleTextCtaClick(event) {
  if (event.currentTarget.classList.contains('nerivio_functions')) {
    dataLayer.push({
      event: "nerivio_functions"
    });
  }

  if (event.currentTarget.classList.contains('learn_more')) {
    dataLayer.push({
      event: "learn_more"
    });
  }

  if (event.currentTarget.classList.contains('doctors_logout')) {
    dataLayer.push({
      event: "doctors_logout"
    });
  }

  if (event.currentTarget.classList.contains('doctor_visit_information')) {
    dataLayer.push({
      event: "doctor_visit_information",
      page: "Homepage"
    });
  }

  if (event.currentTarget.classList.contains('doctor_information')) {
    dataLayer.push({
      event: "doctor_information",
      page: "Homepage"
    });
  }

  const pageUrl = window.location.pathname;
  let pageName = '';
  if (pageUrl === '/de/vorteile-und-anwendung') {
    pageName = "Advantages and Application";
  }
  if (pageUrl === "/de/das-nerivio-system") {
    pageName = "The Nerivio System";
  }
  if (pageUrl === "/de") {
    pageName = "Home Page";
  }
  if (event.currentTarget.classList.contains('three_steps_nerivio')) {
    dataLayer.push({
      event: "three_steps_nerivio",
      page: pageName
    });
  }
}

const textTags = document.querySelectorAll('.nerivio-text-block a');
textTags.forEach(textTag => {
  textTag.addEventListener('click', handleTextCtaClick);
});

function handleBannerClick(event) {
  dataLayer.push({
    event: "banner_click"
  });
  if (window.location.pathname === "/de") {
    pageName = "Home Page";
  }
  if (event.currentTarget.classList.contains('three_steps_nerivio')) {
    dataLayer.push({
      event: "three_steps_nerivio",
      page: pageName
    });
  }
}
const bannerTag = document.querySelector('.nerivio-hero-banner_description .btn-primary');
if (bannerTag) {
  bannerTag.addEventListener('click', handleBannerClick);
}

// Pass event to datalayer on click of footer links.
function handleFooterClick(event) {
  const buttonClicked = event.currentTarget.textContent.trim();
  dataLayer.push({
    event: "footer_click",
    button_clicked: buttonClicked
  });
}
const footerLinks = document.querySelectorAll('.menu__horizontal--item');
footerLinks.forEach(footerLink => {
  footerLink.addEventListener('click', handleFooterClick);
});

document.addEventListener("DOMContentLoaded", function () {
  // On page load push events.
  let pageName = '';
  if (window.location.pathname === "/de/vorteile-und-anwendung") {
    pageName = "advantages_and_application_page";
  }
  if (window.location.pathname === "/de/das-nerivio-system") {
    pageName = "nerivio_system_page";
  }
  if (window.location.pathname === "/de/fuer-fachkreise") {
    pageName = "for_professionals_page";
  }
  dataLayer.push({
    event: pageName
  });

  // When doctor logs in.
  if (window.location.pathname === "/de/fachkreisebereich") {
    if (document.referrer === "https://login.doccheck.com/") {
      dataLayer.push({
        event: "doctors_professional_page"
      });
    }
  }
  // Pushing event on click of order nerivio.
  const shopifyLinks = document.querySelectorAll('a[href*="https://shop.nerivio.de/products/nerivio"]');
  function handleShopifyClick(event) {
    let pageClicked = '';
    if (event.currentTarget.classList.contains('main-menu')) {
      pageClicked = "Category Menu";
    }
    else {
      pageClicked = "Homepage";
    }
    dataLayer.push({
      event: "order_nerivio",
      page: pageClicked
    });
  }
  shopifyLinks.forEach(link => {
    link.addEventListener("click", handleShopifyClick);
  });
  // On Page load of banner.
  const banner = document.querySelector('.nerivio-hero-banner');
  if (banner) {
    dataLayer.push({
      event: "banner_view"
    });
  }
});

// Pushed event on click of banner description links.
function handleBannerDescClick(event) {
  const selectedStep = event.currentTarget.textContent.trim();
  let pageName = '';
  if (window.location.pathname === "/de/vorteile-und-anwendung") {
    pageName = 'advantages_and_application_steps';
  }
  if (window.location.pathname === "/de/das-nerivio-system") {
    pageName = 'nerivio_system_steps';
  }
  if (pageName) {
    dataLayer.push({
      event: pageName,
      selected_step: selectedStep
    });
  }
}
const BannerDescTags = document.querySelectorAll('.product-hero-banner .text-media-description a');
BannerDescTags.forEach(BannerDescTag => {
  BannerDescTag.addEventListener('click', handleBannerDescClick);
});

// Push events on click of Nerivio Media cards.
const mediaCards = document.querySelectorAll('.nerivio-image-card');
function handleCardClick(event) {
  const mediaCard = event.currentTarget;
  if (window.location.pathname === "/de/fachkreisebereich-neu") {
    const loginCardSubject = mediaCard.querySelector('h3').textContent;
    dataLayer.push({
      event: "doctors_subject_area",
      article_name: loginCardSubject
    });
  }
  else {
    const cardTextElement = mediaCard.querySelector('.card_text h3');
    const cardText = cardTextElement ? cardTextElement.textContent : '';
    dataLayer.push({
      event: "nerivio_information",
      selected_article: cardText
    });
  }
}

mediaCards.forEach(mediaCard => {
  mediaCard.addEventListener('click', handleCardClick);
});

// Push events on click of header menu links.
const menuLinks = document.querySelectorAll('.nlevel-menu-default-wrapper .n-level-menu');
function handlemenuClick(event) {
  const button = event.currentTarget.textContent.trim();
  dataLayer.push({
    event: "category_menu",
    button_clicked: button
  });
}
menuLinks.forEach(menuLink => {
  menuLink.addEventListener('click', handlemenuClick);
});

// Push event on Play/Pause of Video.
const videos = document.querySelectorAll('.nerivio-image video');
function handlevideoPlay(event) {
  dataLayer.push({
    event: "nerivio_treatment_video_play"
  });
}
function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
}
function handlevideoPause(event) {
  const watchTime = formatTime(event.target.currentTime.toFixed(2));
  dataLayer.push({
    event: "nerivio_treatment_video_stop",
    watch_time: watchTime
  });
}
videos.forEach(video => {
  video.addEventListener('play', handlevideoPlay);
  video.addEventListener('pause', handlevideoPause);
});

// Push events as user scrolls through the page.
let scrollEventsTriggered = new Set();
function handleScroll() {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercent = Math.round((scrollTop / docHeight) * 100);
  const thresholds = [10, 25, 50, 75, 100];

  thresholds.forEach(threshold => {
    if (scrollPercent >= threshold && !scrollEventsTriggered.has(threshold)) {
      dataLayer.push({
        event: "page_scroll",
        scroll_percentage: `${threshold}%`
      });
      scrollEventsTriggered.add(threshold);
    }
  });
}
window.addEventListener("scroll", handleScroll);
